import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ChevronLeft, Crown, Check } from "lucide-react";
import PhoneFrame from "../components/PhoneFrame.jsx";
import api from "../lib/api.js";

const FEATURES = [
  "Advanced Analytics & Trends",
  "AI Wellness Coach (priority)",
  "Premium Challenges",
  "Full Content Library",
  "Enhanced Rewards (2x multiplier)",
  "Priority Support",
];

export default function Premium() {
  const nav = useNavigate();

  const subscribe = async () => {
    try {
      const r = await api.post("/payments/checkout", {
        package: "premium_monthly",
        origin_url: window.location.origin,
      });
      window.location.href = r.data.url;
    } catch (e) {
      toast.error("Could not start subscription");
    }
  };

  return (
    <PhoneFrame>
      <div className="px-5 pt-6 pb-10">
        <button onClick={() => nav(-1)} className="text-slate-400 inline-flex items-center gap-1 text-sm" data-testid="premium-back">
          <ChevronLeft size={16} /> Back
        </button>

        <div className="mt-6 text-center">
          <div className="w-16 h-16 rounded-full mx-auto bg-[#F59E0B]/20 flex items-center justify-center">
            <Crown size={28} color="#F59E0B" />
          </div>
          <h1 className="ps-heading text-3xl font-bold mt-4">Posture Steps™ Premium</h1>
          <p className="text-slate-400 mt-2">Unlock the full transformation experience.</p>
        </div>

        <div className="mt-7 ps-card p-6 text-center">
          <div className="ps-heading text-5xl font-bold">$9.99</div>
          <div className="text-slate-400 text-sm">per month · cancel anytime</div>
          <button data-testid="premium-subscribe" onClick={subscribe} className="ps-button-primary w-full mt-5">
            Upgrade to Premium
          </button>
        </div>

        <div className="mt-6 space-y-3">
          {FEATURES.map((f) => (
            <div key={f} className="ps-card p-4 flex items-center gap-3" data-testid={`premium-feature-${f.split(" ")[0].toLowerCase()}`}>
              <div className="w-8 h-8 rounded-full bg-[#2fbf71]/15 flex items-center justify-center">
                <Check size={16} color="#2fbf71" />
              </div>
              <div className="font-medium">{f}</div>
            </div>
          ))}
        </div>
      </div>
    </PhoneFrame>
  );
}
